import loop from 'raf-loop'

export let raf = loop()
raf.setMaxListeners(6)
raf.start()

export default raf


// WEBPACK FOOTER //
// ./src/components/game/raf.js